import * as Yup from 'yup';

const createCommentValidationSchema = Yup.object().shape({
  text: Yup.string().required('Please enter your comment')
});

export default createCommentValidationSchema;
